export const getHumanReadableFileSize = (bytes: number, decimalPlaces: number = 2): string => {
    if (bytes <= 0) return '0 B';
    decimalPlaces = decimalPlaces < 0 ? 0 : decimalPlaces;

    const threshold = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(threshold));

    return `${parseFloat((bytes / Math.pow(threshold, i)).toFixed(decimalPlaces))} ${sizes[i]}`;
};

export const getFileTypeIconPath = (fileType: string): string => {
    switch (fileType) {
        case 'doc':
        case 'docx':
            return '/assets/images/file-types/icons@100px/all-word.png';
        case 'jpg':
        case 'jpeg':
            return '/assets/images/file-types/icons@100px/any-image.png';
        case 'pdf':
            return '/assets/images/file-types/icons@100px/pdf.png';
        case 'text':
        case 'txt':
            return '/assets/images/file-types/icons@100px/any-text-or-doc.png';
        case 'xls':
        case 'xlsx':
            return '/assets/images/file-types/icons@100px/all-excel.png';
        default:
            return '/assets/images/file-types/icons@100px/unknown.png';
    }
};


/**
 * Checks if image is an accepted image type.
 *
 * @param image - object
 *
 * @returns boolean
 */
export const isValidImageType = (image: File): boolean => {
    const validDocumentTypes = [
        'image/jpeg',
        'image/png'
    ];
    return validDocumentTypes.includes(image.type);
};

/**
 * Checks if file size is larger than given size in MB
 *
 * @param file - object
 * @param size - size the file must be under in MB
 *
 * @returns boolean
 */
export const isValidFileSize = (file: File, size: number): boolean => {
    return file.size < size * 1000000; // convert to bytes
};

/**
 * Checks if file size is larger than 5MB
 *
 * @param file - object
 *
 * @returns boolean
 */
export const isValidImageSize = (file: File): boolean => {
    return file.size < 5000000; // 5MB in bytes
};
